import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { ISupplierAdmin } from '@bridebook/models/source/models/Suppliers/Admin.types';
import type { IOffer } from '@bridebook/models/source/models/Suppliers/Offers.types';
import { formatBbGift, hasData } from '@bridebook/web/app-shared/lib/supplier/formatters';
import getBBDiscount from './get-bb-discount';

const hasBenefits = ({
  supplier,
  offers,
  premium,
}: {
  supplier: ISupplier;
  offers?: IOffer[] | null;
  premium?: ISupplierAdmin['premium'];
}): boolean => {
  const discount = premium ? undefined : getBBDiscount(offers);
  const gift = premium
    ? formatBbGift(
        (supplier as ISupplier).bridebook?.gift,
        (supplier as ISupplier).bridebook?.giftOther,
      )
    : undefined;
  const offer = premium ? (supplier as ISupplier).bridebook?.offer : undefined;
  const benefitsValues = [discount, gift, offer];

  return hasData(benefitsValues);
};

export default hasBenefits;
